
        require('./index.scss');
        'use strict';

require('module/home-index/header/header-nav');

require('module/home-index/home-toutiao');

require('module/home-detail/breadcrumbs');

require('module/home-detail/friend-link');

require('module/home-index/right-toolbar');

require('module/home-index/decoration-cal');

require('module/home-index/design-free');

require('@front-end/common-module-vm/feedback-dialog');

require('module/home-list/cross-ad');

require('module/home-list/bottom-ad');

require('module/home-list/sidebar-ad');

require('module/home-index/mobile-verify');

var $ = window.$;

function getList(curr, total) {
    if (curr > total) curr = total;
    var ls = [];
    var right = total - curr > 3 ? 3 : total - curr;
    var left = curr - 1 > 3 ? 3 : curr - 1;
    var start = curr - left;
    var end = curr + right;
    if (right > 0 && left > 0) {
        for (var i = start; i <= end; i++) {
            ls.push(i);
        }
    } else if (right > 0) {
        for (var _i = curr; _i <= end; _i++) {
            ls.push(_i);
        }
    } else if (left > 0) {
        for (var _i2 = start; _i2 <= curr; _i2++) {
            ls.push(_i2);
        }
    } else if (curr === total) {
        ls = [1];
    }
    return ls;
}

var _module = {
    current: $('.content .foot ul').data('current'),
    total: $('.content .foot ul').data('total'),
    renderPage: function renderPage() {
        var curr = this.current;
        var total = this.total;
        var ls = getList(curr, total);
        if (ls.length) {
            var len = ls.length;
            for (var i = ls[len - 1]; i >= ls[0]; i--) {
                var li = $('<li class="num">' + i + '</li>');
                if (i === curr) li.attr('class', 'active num');
                if ($('#previous')[0]) {
                    $('#previous').after(li);
                }
            }
            if (ls[len - 1] < total) {
                $('.num:last').after($('<span style="margin: 0 5px">......</span><li class="num">' + total + '</li>'));
            }
            if (ls[0] > 1) {
                $('.num:first').before($('<li class="num">1</li><span  style="margin: 0 5px">......</span>'));
            }
        }
    },
    toggle: function toggle(selector) {
        var btn = $(selector);
        var symbol = $('<div></div>');
        symbol.addClass('symbol');
        var list = $('.nav-header-wrap').find('li');
        btn.click();
        for (var i = 0; i < list.length; i++) {
            if (list.eq(i).hasClass('cur')) list.eq(i).removeClass('cur');
            if (list.eq(i).find('a').length > 1) {
                list.eq(i).addClass('cur');
                // list.eq(i).append(symbol);
            }
        }
    },
    switchPage: function switchPage() {
        var curr = this.current;
        var total = this.total;
        $('.foot ul').find('li').click(function (e) {
            var btn = $(e.target);
            var current = window.location.href;
            var type = btn.attr('class');
            var num = 0;
            if (type === 'control') {
                var id = btn.attr('id');
                if (id === 'next') {
                    num = curr + 1 <= total ? curr + 1 : total;
                } else if (id === 'previous') {
                    num = curr - 1 > 0 ? curr - 1 : 1;
                }
            } else if (type.indexOf('num') > -1) {
                num = parseInt(btn.text());
            }
            if (num) {
                var target = current.replace(/companies(.*)/, 'companies/n' + num);
                window.location.href = target;
            }
        });
    },
    handlePage: function handlePage() {
        var empty = $('.empty');
        if (empty.length) {
            $('.foot').remove();
        }
    },
    removeBtn: function removeBtn() {
        $('.clause-data-block').removeClass('active');
        $('.btn-open-platform:first').remove();
        $('.btn-open-wx').remove();
    },
    init: function init() {
        this.removeBtn();
        this.renderPage();
        this.switchPage();
        this.toggle('.cal-design .design-free');
        this.handlePage();
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/page/home-companies/index.js